import React from "react";

const NotFound = () => {
    return (
        <div className="not-found">
            <img src={'/img/error-404.jpg'} alt="Page not found" className="img-responsive" />
            <h3>You have landed on a page that doesn't exist.</h3>
        </div>
    )
}

export default NotFound;